import { render, staticRenderFns } from "./passenger.vue?vue&type=template&id=6af9f2fe"
import script from "./passenger.vue?vue&type=script&lang=js"
export * from "./passenger.vue?vue&type=script&lang=js"
import style0 from "./passenger.vue?vue&type=style&index=0&id=6af9f2fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports